import { API_V4 } from "@/services/config/auth-axios";

class OtpService {
  activeSms(mobile) {
    return API_V4.post(`/verification/otp/sms`, {
      mobile
    });
  }

  activeGoogle() {
    return API_V4.post(`/verification/otp/google2fa`, {});
  }
  activeEmail(email) {
    return API_V4.post(`/verification/otp/email`, {
      email
    });
  }
  verify(strategy, code, password) {
    return API_V4.post(`/verification/otp/${strategy}/verify`, {
      code,
      password
    });
  }

  verifyAndDefault(strategy, code, password) {
    return API_V4.post(`/verification/otp/${strategy}/verify-and-set-default`, {
      code,
      password
    });
  }

  inactive(password) {
    return API_V4.post(`/verification/otp/deactivate-all`, {
      password
    });
  }

  setDefault(strategy) {
    return API_V4.get(`/verification/otp/${strategy}/default`);
  }
  otpChannels(type, refNo) {
    return API_V4.get(`/verification/multi-factor-otp/channels`, {
      params: {
        otp_type: type,
        ref_no: refNo
      }
    });
  }
  sendOtp(data) {
    return API_V4.post(`/verification/multi-factor-otp/send`, data);
  }
  verifyOtp(data) {
    return API_V4.post(`/verification/multi-factor-otp/verify`, data);
  }
}

export default new OtpService();
